module.exports = __webpack_public_path__ + "img/znzs-2-sm.e5bd853b.jpg";